import { render, staticRenderFns } from "./AppInfo.vue?vue&type=template&id=c9247f9a&scoped=true&"
import script from "./AppInfo.vue?vue&type=script&lang=js&"
export * from "./AppInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppInfo.vue?vue&type=style&index=0&id=c9247f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9247f9a",
  null
  
)

export default component.exports